import { render, staticRenderFns } from "./BlockDetail.vue?vue&type=template&id=2d4b3313&scoped=true&"
import script from "./BlockDetail.vue?vue&type=script&lang=js&"
export * from "./BlockDetail.vue?vue&type=script&lang=js&"
import style0 from "./BlockDetail.vue?vue&type=style&index=0&id=2d4b3313&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b3313",
  null
  
)

export default component.exports